import script from "./PnlPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PnlPage.vue?vue&type=script&setup=true&lang=ts"

import "./PnlPage.vue?vue&type=style&index=0&id=56d15fb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d15fb3"]])

export default __exports__